<script lang="ts" generics="T">
    import Button from "@components/button/Button.svelte"

    export let list: Set<T>
    export let selected: T
    export let select: (selected: T) => void
</script>

<ul class="flex gap-2 rounded-full mt-2">
    {#each list as item}
        {@const on = selected === item}
        <Button
            small
            go={() => select(item)}
            color={on ? "purple" : "white"}
            class="inline-block rounded-md px-3"
        >
            {item}
        </Button>
    {/each}
</ul>
